import { useEffect, useState } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

/** Delay avoids flashes on fast responses; no invented percentage. */
export function ActivityIndicator() {
  const fetching = useIsFetching({ predicate: (query) => query.state.data === undefined });
  const mutating = useIsMutating();
  const busy = fetching + mutating > 0;
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!busy) {
      setVisible(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setVisible(true), 350);
    return () => window.clearTimeout(timer);
  }, [busy]);
  return visible ? (
    <div
      className="app-activity"
      role="status"
      aria-label={mutating ? 'Enregistrement en cours' : 'Chargement en cours'}
    >
      <span />
    </div>
  ) : null;
}
